import React from "react";
import FormContainer from "shared/form";
import { SearchCriteriaProps } from "./types";
import { useSearchCriteriaService } from "./service";
import { useCopies } from "shared/hooks/useCopies";
import ButtonType from "shared/enums/ButtonTypes";
import { useFormikContext } from "formik";
import { SearchCriteriaItem } from "apps/console/modules/program/workflow/enrollment/list/types";
import classNames from "classnames";
import Icon from "assets/icons";
import Variant from "shared/enums/Variant";
import Button from "shared/components/button";
import ButtonGroup from "../button/components/buttonGroup";

export function SearchCriteria(props: SearchCriteriaProps) {
  const service = useSearchCriteriaService(props);
  const copies = useCopies();
  const [resetkey, setResetKey] = React.useState(0);

  return (
    <div
      key={resetkey}
      className={classNames("searchCriteria", props.className && props.className, {
        threeColumn: props.threeColumn
      })}>
      <FormContainer
        innerRef={props.formRef}
        enableReinitialize
        onSubmit={service.handleSubmit as any}
        initialValues={service.initialValues}
        validationSchema={service.validationSchema}>
        <FormContainer.Form className="searchCriteria_wrapper">
          <div className="searchCriteria_form">{service.fields}</div>
          <div className="searchCriteria_footer">
            <DisplayError />
            <ButtonGroup inlineFormButtons>
              <Button.Save
                icon={<Icon.Search size={15} />}
                type={ButtonType.SUBMIT}
                label={copies.get(props.submitButtonText)}
              />
              <FormResetButton reset={props.handleReset} setResetKey={setResetKey}></FormResetButton>
            </ButtonGroup>
          </div>
        </FormContainer.Form>
      </FormContainer>
    </div>
  );
}

function FormResetButton({
  reset,
  setResetKey
}: {
  reset?: Function;
  setResetKey: React.Dispatch<React.SetStateAction<number>>;
}) {
  const { handleReset } = useFormikContext<any>();
  const copies = useCopies();
  return (
    <Button
      className="searchCriteria_resetBtn"
      variant={Variant.ERROR}
      icon={<Icon.Close />}
      label={copies.get("reset")}
      isOutline
      title={copies.get("reset")}
      onClick={() => {
        handleReset();
        reset?.();
        setResetKey(prev => prev + 1);
      }}
    />
  );
}

function DisplayError() {
  const { errors, submitCount } = useFormikContext<{ allFieldsEmpty: string }>();
  if (errors?.allFieldsEmpty && submitCount > 0) {
    return <div className="hasError">{errors.allFieldsEmpty}</div>;
  }
  return null;
}

export function DisplaySearchCriteriaAsHeader({
  searchCriteriaItems
}: {
  searchCriteriaItems: Array<SearchCriteriaItem>;
}) {
  return (
    <div style={{ display: "flex", gap: 6 }}>
      {searchCriteriaItems
        .filter(item => !item.internal)
        .map(item => (
          <div key={item.filterTypeId}>
            {item.filterTypeLabel}: {item.filterValueLabel}
          </div>
        ))}
    </div>
  );
}
